import { Field, Input, InputArea, Select } from '@cloudflare/kumo';

export interface CustomFieldDef { id: string; key: string; name: string; type: string; description?: string | null }

/** ISO UTC → "aaaa-mm-ddThh:mm" no horário de Brasília (campo datetime-local) */
export function isoToLocalInput(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Date(d.getTime() - 3 * 3_600_000).toISOString().slice(0, 16);
}

/** Campos personalizados no formulário do contato */
export function ContactCustomFields({ fields, values, onChange }: {
  fields: CustomFieldDef[];
  values: Record<string, string>;
  onChange: (key: string, value: string) => void;
}) {
  if (!fields.length) return null;
  return (
    <div className="flex flex-col gap-4" style={{ borderTop: '1px solid var(--border)', paddingTop: 16 }}>
      <p className="font-semibold">Campos personalizados</p>
      {fields.map((f) => {
        const value = values[f.key] ?? '';
        if (f.type === 'boolean') {
          const options = [
            { value: 'true', label: 'Sim' },
            { value: 'false', label: 'Não' },
          ];
          return (
            <Field label={f.name} description={f.description || undefined} key={f.id}>
              <Select value={(options.find((o) => o.value === value) ?? null)?.value ?? null} items={options} onValueChange={(value: string | null) => onChange(f.key, value ?? '')} placeholder="Selecione" />
            </Field>
          );
        }
        if (f.type === 'longText') {
          return (
            <Field label={f.name} description={f.description || undefined} key={f.id}>
              <InputArea onChange={(e) => onChange(f.key, e.target.value)} aria-label={f.name} value={value} />
            </Field>
          );
        }
        if (f.type === 'date' || f.type === 'datetime') {
          const id = `cf-${f.id}`;
          return (
            <div key={f.id} className="flex flex-col gap-1">
              <label htmlFor={id} style={{ fontWeight: 600, fontSize: 13, color: 'var(--text)' }}>{f.name}</label>
              {f.description && <p className="text-xs !text-[var(--text-muted)]">{f.description}</p>}
              <input
                id={id}
                type={f.type === 'date' ? 'date' : 'datetime-local'}
                value={f.type === 'datetime' && value.includes('Z') ? isoToLocalInput(value) : value}
                onChange={(e) => onChange(f.key, e.target.value)}
                style={{ padding: '7px 12px', border: '1px solid var(--border-strong)', borderRadius: 6, fontSize: 13, fontFamily: 'inherit' }}
              />
            </div>
          );
        }
        // O `Input` do Cloudscape não aceita `type="tel"`: o teclado de telefone
        // vem do `inputMode`.
        const type = f.type === 'number' ? 'number' : f.type === 'email' ? 'email' : 'text';
        return (
          <Field label={f.name} description={f.description || undefined} key={f.id}>
            <Input onChange={(e) => onChange(f.key, e.target.value)} aria-label={f.name} type={type} inputMode={f.type === 'phone' ? 'tel' : undefined} value={value} />
          </Field>
        );
      })}
    </div>
  );
}

